export enum InventoryVehicleLineTemplateType {
  Purchase = 'purchase',
  Sale = 'sale',
  Both = 'both'
}
